import { signal } from '@preact/signals';

/** Per-device UI preferences — not account data, so localStorage is the
 * right place (no server round-trip needed, ADR-0003's "reads only from
 * local storage" spirit extends naturally to UI-only settings too). */

export type TextSize = 'condensed' | 'medium' | 'large';
const TEXT_SIZE_KEY = 'foyer_text_size';

function detectInitialTextSize(): TextSize {
  try {
    const stored = localStorage.getItem(TEXT_SIZE_KEY);
    if (stored === 'condensed' || stored === 'medium' || stored === 'large') return stored;
  } catch {
    // Ignore; default below.
  }
  return 'medium';
}

export const textSize = signal<TextSize>(detectInitialTextSize());

export function setTextSize(size: TextSize): void {
  textSize.value = size;
  try {
    localStorage.setItem(TEXT_SIZE_KEY, size);
  } catch {
    // Per-device preference only; losing it just means it resets next visit.
  }
  document.documentElement.dataset.textSize = size;
}

document.documentElement.dataset.textSize = textSize.value;
